//Chating pagination limit configuration file
export const chatPaginationLimit=10;